import { useContext, useEffect, useState } from "react";
import { ParagraphText, UBInput } from "../../../../Libraries";
import { InputSearchIcon } from "../../../../assets/icons/icon";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box, Tab, Tabs } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import useDebouncedValue from "../../../../hooks/useDebouncedValue";
import { sentenceCase } from "../../../../constants";
import { removeAllSpaces } from "../../../../utils";
import PackageDetail from "./PackageDetail";
import styles from "./PackageSection.module.css";

const PackageSection = ({
  setState,
  bundleTypes,
  bundles,
  selectedPackage,
  onNext,
}) => {
  const [I18n] = useContext(LanguageContext);
  const [tabValue, setTabVal] = useState("all");
  const [searchQ, setSearchQ] = useState("");
  const [types, setType] = useState([]);
  const [searchList, setSearchList] = useState([]);

  const debounceQ = useDebouncedValue(searchQ, 500);

  const onChangeTab = (event, newValue) => {
    setSearchQ("");
    setTabVal(newValue);
  };

  useEffect(() => {
    if (bundleTypes?.length) {
      setType(
        bundleTypes.map((item) => ({
          label: item,
          value: item,
        })),
      );
    }
  }, [bundleTypes]);

  useEffect(() => {
    if (debounceQ) {
      const tabPackages =
        tabValue === "all"
          ? Object.values(bundles).flat(1)
          : bundles[tabValue] || [];
      setSearchList(
        tabPackages.filter((x) =>
          x.offer_name.toLowerCase().includes(debounceQ.toLowerCase()),
        ),
      );
    } else {
      setSearchList([]);
    }
  }, [debounceQ, tabValue, bundles]);

  const packages = debounceQ
    ? searchList
    : tabValue === "all"
      ? Object.values(bundles).flat(1)
      : bundles[tabValue] || [];

  const handlePackageSelect = (data) => {
    triggerLogEvent(analytics, "w_earn_ep_packages_select");
    setState((e) => ({
      ...e,
      offer: data,
      amount: data?.price,
    }));
    onNext();
  };

  return (
    <Box className={styles.PackageSection}>

      <Box className={styles.PackageSectionContent}>
        <Box className={styles.PackageSectionBody}>
          <UBInput
            inputId="package_modal_search"
            name="search"
            label={I18n.select_package}
            value={searchQ}
            placeholder={I18n.search_package}
            onChange={(_, text) => setSearchQ(text)}
            inputClassname={styles.searchInput}
            baseClassname={styles.searchInputBase}
            prefix={<InputSearchIcon />}
            onFocus={() => triggerLogEvent(analytics, "acc_search_performed")}
            error={false}
          />
          <Box className={styles.PackageSectionTabs}>
            <Tabs
              id="easyload_package_type_tabs"
              value={tabValue}
              onChange={onChangeTab}
              textColor="primary"
              indicatorColor="primary"
              aria-label="package type tabs"
              variant="scrollable"
              scrollButtons={false}
            >
              {[{ label: "all", value: "all" }, ...types].map((tab) => (
                <Tab
                  key={tab.value}
                  id={`${removeAllSpaces(tab.value)}_tabId`}
                  value={tab.value}
                  label={sentenceCase(tab.label)}
                  sx={{ textTransform: "none" }}
                />
              ))}
            </Tabs>
          </Box>
          <Box className={styles.PackageSectionListShell}>
            <Box
              className={`${styles.PackageSectionContentBody} generic-scrollbar`}
            >
              {debounceQ && !(packages.length > 0) ? (
                <Box className="w-100 marginTop30">
                  <ParagraphText className="textCenter fontSize14 foundationGreyNormal">
                    {I18n.package_not_found}
                  </ParagraphText>
                </Box>
              ) : (
                packages.map((pkg, index) => (
                  <PackageDetail
                    key={pkg?.id ?? index}
                    packageData={pkg}
                    onSelect={handlePackageSelect}
                    isSelectedPackage={selectedPackage?.id === pkg?.id}
                  />
                ))
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PackageSection;
